"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HelpCenterService = void 0;
const axios_1 = __importDefault(require("axios"));
const environment_1 = require("../../constants/environment");
const environment_enum_1 = require("../enum/environment.enum");
class HelpCenterService {
    constructor(ENV = environment_enum_1.ENVIRONMENT.DEV, key) {
        this.RESOURCE = 'user';
        //No se guarda la respuesta
        this.getZendeskUser = async (user) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/support/user`;
            const response = await axios_1.default.post(URL, JSON.stringify(user), { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.getUserTickets = async (user) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/support/user/${user}/tickets`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        //No se guarda la respuesta
        this.getCategories = async () => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/support/categories`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.getCategoriesArticles = async (tagName) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/support/categories/${tagName}`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.getTicketById = async (ticketId) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/support/ticket/${ticketId}`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.getTicketComments = async (ticketId) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/support/ticket/${ticketId}/comments`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.uploadFile = async (file) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/support/files`;
            const response = await axios_1.default.post(URL, file, { headers: { 'x-api-key': this.KEY, 'Content-Type': 'multipart/form-data' } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.postTicket = async (ticketData) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/support/user/${ticketData.ticketData.zendeskId}/tickets`;
            const response = await axios_1.default.post(URL, ticketData, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.postComment = async (commentData) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/support/ticket/${commentData.commentData.ticket_id}/comments`;
            const response = await axios_1.default.post(URL, commentData, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.ENV = ENV;
        this.KEY = key;
    }
}
exports.HelpCenterService = HelpCenterService;
